module.exports = __webpack_public_path__ + "static/smads_logo-42a19360ffc3baadd3390a66e580ff15.jpg";